/* eslint-disable */
export default {
  inAMeeting: 'En una reunión',
  onMyWay: 'En camino',
  callMeBackIn: 'Devuélvame la llamada en...',
  willCallYouBackIn: 'Le devolveré la llamada en...',
  hour: 'hora',
  min: 'min',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
